export default __webpack_public_path__ + "static/QR_right-676e114ee97957fe9428ba4ab87d2364.svg";